// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  loginStatus: {
    data: null,
  },
  getAudioListStatus: { data: null },
  createAudioStatus: { data: null },
  editAudioStatus: { data: null },
  deleteAudioStatus: { data: null },
};
